export const ENTER_FULLSCREEN_CLICK_ID = "203351";
export const EXIT_FULLSCREEN_CLICK_ID = "203352";
export const LIST_MENU_ICON_CLICK_ID = "203349";
export const LIST_MENU_ENTRY_CLICK_ID = "203350";
export const LOCATION_TOURTIP_CTA_CLICK_ID = "203348";
export const LOCATION_TOURTIP_CLOSE_CLICK_ID = "203348";
